import * as React from 'react';
import { brandColors, companyLogo, companyConfig } from '../config/colors';

interface ClassConfirmationEmailProps {
  name?: string;
  company?: string;
  classId?: string;
  courseName?: string;
  instructorName?: string;
  locationAddress?: string;
  startDate?: string;
  endDate?: string;
  status?: string;
  orgName?: string;
  domain?: string;
  industry?: string;
  supportEmail?: string;
}

export const ClassConfirmationEmail: React.FC<ClassConfirmationEmailProps> = ({
  name = 'João Silva',
  company = companyConfig.name,
  classId = 'CLS-12345',
  courseName = 'Fundamentos de Analytics',
  instructorName = 'Dra. Ana Soares',
  locationAddress = 'Av. Paulista, 1000 - Sala 203, São Paulo - SP',
  startDate = '15 Abr, 2025 - 09:00',
  endDate = '15 Abr, 2025 - 17:00',
  status = 'confirmada',
  orgName = 'Empresa XYZ',
  domain = companyConfig.domain,
  industry = 'Tecnologia',
  supportEmail = companyConfig.supportEmail,
}) => {
  return (
    <div style={containerStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <img 
          src={companyLogo}
          alt={companyConfig.name}
          style={logoImageStyle}
        />
      </div>
      
      {/* Content */}
      <div style={contentStyle}>
        <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ backgroundColor: brandColors.background }}>
          <tr>
            <td align="center" style={{ padding: '40px 20px' }}>
              <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ maxWidth: '400px' }}>
                {/* Círculo com check */}
                <tr>
                  <td align="center" style={{ paddingBottom: '30px' }}>
                    <div style={{ 
                      width: '60px', 
                      height: '60px', 
                      borderRadius: '50%', 
                      backgroundColor: brandColors.primary, 
                      display: 'inline-block',
                      textAlign: 'center',
                      lineHeight: '60px'
                    }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="white"/>
                      </svg>
                    </div>
                  </td>
                </tr>
                
                {/* Título */}
                <tr>
                  <td align="center" style={{ paddingBottom: '15px' }}>
                    <h1 style={{ 
                      margin: '0',
                      fontSize: '28px',
                      color: '#333333',
                      fontWeight: '600'
                    }}>
                      Aula Confirmada!
                    </h1>
                  </td>
                </tr>
                
                {/* Mensagem */}
                <tr>
                  <td align="center" style={{ paddingBottom: '25px' }}>
                    <p style={{ 
                      margin: '0',
                      fontSize: '16px',
                      color: '#666666'
                    }}>
                      Sua participação foi registrada com sucesso.
                    </p>
                  </td>
                </tr>
                
                {/* Badge do ID da aula */}
                <tr>
                  <td align="center">
                    <div style={{ 
                      backgroundColor: brandColors.secondary,
                      borderRadius: '24px',
                      color: brandColors.white,
                      fontWeight: '600',
                      fontSize: '15px',
                      padding: '12px 25px',
                      display: 'inline-block'
                    }}>
                      Aula #{classId}
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        
        <div style={contentContainerStyle}>
          <h2 style={titleStyle}>Olá, {name}!</h2>
        </div>
        
        <div style={courseCardStyle}>
          <div style={courseHeaderStyle}>
            <h3 style={courseTitleStyle}>{courseName}</h3>
          </div>
          
          <div style={courseDetailsStyle}>
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Data de Início:</div>
                <div style={detailValueStyle}>{startDate}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Data de Término:</div>
                <div style={detailValueStyle}>{endDate}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 7c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H6v-.99c.2-.72 3.3-2.01 6-2.01s5.8 1.29 6 2v1z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Instrutor:</div>
                <div style={detailValueStyle}>{instructorName}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Local:</div>
                <div style={detailValueStyle}>{locationAddress}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#4CAF50"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Status:</div>
                <div style={{ ...detailValueStyle, color: '#4CAF50', fontWeight: '600' }}>
                  {status.charAt(0).toUpperCase() + status.slice(1)}
                </div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Organização:</div>
                <div style={detailValueStyle}>{orgName}</div>
              </div>
            </div>
          </div>
        </div>
        
        <div style={nextStepsStyle}>
          <h3 style={nextStepsTitleStyle}>Próximos Passos</h3>
          <p style={paragraphStyle}>
            Chegue com 15 minutos de antecedência para o credenciamento. Caso precise de ajuda, nossa equipe estará disponível para auxiliá-lo.
          </p>
          <div style={buttonContainerStyle}>
            <a href="#" style={buttonStyle}>
              Ver Detalhes da Aula
            </a>
          </div>
        </div>
        
        <hr style={hrStyle} />
        
        <div style={footerContentStyle}>
          <p style={footerStyle}>
            Se você tiver alguma dúvida, entre em contato conosco:
          </p>
          <div style={contactChannelsStyle}>
            <p style={contactChannelStyle}>✉️ {companyConfig.supportEmail}&nbsp;&nbsp;📱 {companyConfig.phone}</p>
          </div>
          <p style={footerStyle}>
            Atenciosamente,<br />
            Equipe {company}
          </p>
        </div>
      </div>
      
      {/* Footer */}
      <div style={emailFooterStyle}>
        <p style={copyrightStyle}>
          © 2025 {companyConfig.name}. Todos os direitos reservados.
        </p>
        <div style={footerLinksStyle}>
          <a href="#" style={footerLinkStyle}>Termos de Uso</a>
          <span style={footerDividerStyle}>|</span>
          <a href="#" style={footerLinkStyle}>Política de Privacidade</a>
        </div>
      </div>
    </div>
  );
};

// Estilos
const brandColor = brandColors.primary;
const accentColor = brandColors.secondary;
const backgroundColor = brandColors.background;
const textColor = brandColors.text;
const secondaryTextColor = brandColors.secondaryText;

const containerStyle = {
  fontFamily: "'Satoshi', Arial, sans-serif",
  maxWidth: '600px',
  margin: '0 auto',
  backgroundColor: backgroundColor,
};

const headerStyle = {
  backgroundColor: brandColors.header,
  padding: '15px',
  textAlign: 'center' as const,
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
};

const logoImageStyle = {
  maxWidth: '140px',
  height: 'auto',
  display: 'block',
  margin: '0 auto',
};

const contentStyle = {
  backgroundColor: brandColors.white,
  borderRadius: '0 0 8px 8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
  padding: '0',
  margin: '0 0 20px 0',
  overflow: 'hidden',
};

const contentContainerStyle = {
  padding: '0 40px',
};

const titleStyle = {
  fontSize: '24px',
  fontWeight: '600',
  color: brandColor,
  marginBottom: '16px',
  padding: '24px 0 0 0',
};

const paragraphStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  color: textColor,
  margin: '16px 0',
  padding: '0 40px',
};

const courseCardStyle = {
  border: `1px solid ${brandColors.border}`,
  borderRadius: '8px',
  overflow: 'hidden',
  margin: '24px 40px',
};

const courseHeaderStyle = {
  backgroundColor: brandColor,
  padding: '16px 24px',
};

const courseTitleStyle = {
  margin: '0',
  color: brandColors.white,
  fontSize: '18px',
  fontWeight: '600',
};

const courseDetailsStyle = {
  padding: '20px 24px',
  backgroundColor: brandColors.white,
};

const detailBlockStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: '16px',
};

const detailIconContainerStyle = {
  width: '24px',
  marginRight: '12px',
  paddingTop: '2px',
};

const detailLabelStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  fontWeight: '500',
  marginBottom: '4px',
};

const detailValueStyle = {
  fontSize: '15px',
  color: textColor,
  fontWeight: '500',
};

const nextStepsStyle = {
  padding: '8px 0 24px 0',
};

const nextStepsTitleStyle = {
  fontSize: '18px',
  fontWeight: '600',
  color: brandColor,
  margin: '0 0 16px 0',
  padding: '0 40px',
};

const buttonContainerStyle = {
  textAlign: 'center' as const,
  margin: '32px 0',
};

const buttonStyle = {
  backgroundColor: brandColor,
  borderRadius: '6px',
  color: brandColors.white,
  fontSize: '16px',
  fontWeight: '600',
  textDecoration: 'none',
  padding: '12px 24px',
  display: 'inline-block',
  transition: 'background-color 0.3s ease',
};

const hrStyle = {
  borderColor: brandColors.border,
  margin: '24px 40px',
};

const footerContentStyle = {
  padding: '0 40px 32px 40px',
};

const footerStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  margin: '8px 0',
};

const contactChannelsStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  marginBottom: '20px',
  marginTop: '8px',
};

const contactChannelStyle = {
  fontSize: '15px',
  color: textColor,
  margin: '6px 0',
  fontWeight: '500',
};

const emailFooterStyle = {
  backgroundColor: backgroundColor,
  padding: '24px 40px',
  textAlign: 'center' as const,
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
};

const copyrightStyle = {
  fontSize: '13px',
  color: secondaryTextColor,
  margin: '0 0 12px 0',
};

const footerLinksStyle = {
  margin: '8px 0',
};

const footerLinkStyle = {
  color: brandColor,
  textDecoration: 'none',
  fontSize: '13px',
  fontWeight: '500',
};

const footerDividerStyle = {
  color: secondaryTextColor,
  margin: '0 8px',
};

export default ClassConfirmationEmail; 